// REACT & REACT HOOKS
import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// COMPONENTS
import Loader from "components/shared/loader";

// STORE ACTIONS
import { loginUser } from "store/actions";

// STYLES & ASSETS
import LoginLogo from "./assets/full-logo.png";
import styles from "./styles/style.module.scss";
import { ReactComponent as LockIcon } from "./assets/lock.svg";
import { ReactComponent as EmailIcon } from "./assets/email.svg";

// UI COMPONENTS
import { Container, Form } from "react-bootstrap";

function Login() {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.authentication);
  if (error) toast(error, { toastId: error });
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    data.roleGroup = "partners";
    dispatch(loginUser({ data, navigate }));
  };
  if (loading) return <Loader full />;

  return (
    <>
      <div className={styles["login-page"]}>
        <div className="login-wrapper">
          <Container>
            <div className="login-form">
              <div className="login-logo">
                <img src={LoginLogo} alt="" />
              </div>
              <div className="login-data">
                <h3>أهلا بعودتك</h3>
                <p>برجاء تسجيل الدخول</p>
              </div>
              <div className="login-form">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Form.Group className="input-container">
                    <EmailIcon />

                    <Form.Control
                      {...register("email")}
                      placeholder="Email Address"
                    />
                  </Form.Group>
                  <Form.Group className="input-container">
                    <LockIcon />

                    <Form.Control
                      type="password"
                      {...register("password")}
                      placeholder="Password"
                      autoComplete="off"
                    />
                  </Form.Group>
                  <Form.Group className="input-container">
                    <button type="submit" className="btn">
                      دخول
                    </button>
                  </Form.Group>
                </form>
                {errors.exampleRequired && <span>This field is required</span>}
              </div>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Login;
